var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppConfig from '../config/config';
const SHOPIFY_GRAPHQL_URL = `https://${AppConfig.searchSettings.shopify.domain}/api/2024-10/graphql.json`;
const PROMO_MESSAGES_QUERY = `
  query PromoMessages($first: Int!) {
    metaobjects(type: "plp_promo_message", first: $first) {
      nodes {
        handle
        displayText:     field(key: "display_text")     { value }
        textColor:       field(key: "text_color")       { value }
        backgroundColor: field(key: "background_color") { value }
      }
    }
  }
`;
let cache = null;
let inFlight = null;
/**
 * Fetch `plp_promo_message` metaobjects via the Storefront API.
 * Result is cached at module scope for the session — first caller triggers
 * the network request, subsequent callers await the same Promise, and every
 * caller after resolution gets the cached map synchronously via the returned Promise.
 *
 * TODO: if additional metaobject types get added to the app (e.g. badges, size
 * guides, editorial content), combine them into a single Storefront API request
 * using multiple aliased `metaobjects(type: "...")` queries in one operation,
 * instead of one round-trip per type. Move shared fetch/cache plumbing into a
 * generic `fetchMetaobjectMaps({ types: [...] })` helper at that point.
 */
export function fetchPromoMessageMap() {
    if (cache)
        return Promise.resolve(cache);
    if (inFlight)
        return inFlight;
    inFlight = (() => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        try {
            const response = yield fetch(SHOPIFY_GRAPHQL_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': AppConfig.searchSettings.shopify.storefrontToken,
                },
                body: JSON.stringify({
                    query: PROMO_MESSAGES_QUERY,
                    variables: { first: 50 },
                }),
            });
            if (!response.ok) {
                cache = new Map();
                return cache;
            }
            const payload = yield response.json();
            const nodes = (_c = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.data) === null || _a === void 0 ? void 0 : _a.metaobjects) === null || _b === void 0 ? void 0 : _b.nodes) !== null && _c !== void 0 ? _c : [];
            const map = new Map();
            for (const node of nodes) {
                if (!(node === null || node === void 0 ? void 0 : node.handle) || !((_d = node.displayText) === null || _d === void 0 ? void 0 : _d.value))
                    continue;
                map.set(node.handle.toLowerCase().trim(), {
                    handle: node.handle,
                    displayText: node.displayText.value,
                    textColor: (_f = (_e = node.textColor) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : null,
                    backgroundColor: (_h = (_g = node.backgroundColor) === null || _g === void 0 ? void 0 : _g.value) !== null && _h !== void 0 ? _h : null,
                });
            }
            cache = map;
            return cache;
        }
        catch (_j) {
            cache = new Map();
            return cache;
        }
        finally {
            inFlight = null;
        }
    }))();
    return inFlight;
}
/** Synchronous accessor for the cached map. Returns null before the first fetch resolves. */
export function getCachedPromoMessageMap() {
    return cache;
}
